import Ajax from '@utils/ajax';

export default {
  toggleLike(commentId, options = {}) {
    return Ajax.post({
      url: `/comments/${commentId}/comment_likes`,
      ...options,
    });
  },

  create(group, recObject, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/comments`,
      data: {
        rec_object_id: recObject && recObject.id,
        comment: data,
      },
      ...options,
    });
  },

  update(group, comment, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/comments/${comment.id}`,
      data: {
        _method: 'PUT',
        comment: data,
      },
      ...options,
    });
  },

  delete(group, comment, spamChecked, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/comments/${comment.id}`,
      data: {
        _method: 'DELETE',
        spam_checked: spamChecked || null,
      },
      ...options,
    });
  },
};
